module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('list-view', {
    staticClass: "component-position-selector"
  }, _vm._l((_vm.componentPositions), function(position) {
    return _c('div', {
      staticClass: "component-position",
      attrs: {
        "selected": position.index == _vm.value
      },
      on: {
        "click": function($event) {
          _vm.positionSelected(position.index)
        }
      }
    }, [_vm._v("\n    " + _vm._s(_vm.getComponentPositionName(_vm.componentType, position.index)) + "\n  ")])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0975955e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/component-position-selector.vue
// module id = 191
// module chunks = 5